module.exports = __webpack_public_path__ + "static/media/08_tn.220feaaf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/thumbnails/08_tn.jpg
// module id = 317
// module chunks = 0